import loadReduxAction from 'modules/redux/actions/load'
import {
  WORKOUTS_ACTION,
  WORKOUTS_DOMAIN,
  WORKOUTS_ENDPOINT,
  WORKOUTS_PATH
} from 'modules/workout/redux/constants'
import getEndpointTrainingUtil from 'modules/training/utils/get-endpoint'
import getPathFromDomainPathReduxUtil from 'modules/redux/utils/get-path-from-domain-map-path'
import { WORKOUT_CLASS_NAME } from 'modules/training/models/workout/constants'
import interpolateRouteUtil from 'modules/routes/utils/interpolate'
import {
  getObjectUtil,
  logUtil
} from 'packages/src'

function loadByIdWorkoutAction (props = {}) {
  const id = props.id || getObjectUtil(props, 'match.props.id')
  const logPrefix = `id=${id}`
  logUtil('loadByIdWorkoutAction').debug(`${logPrefix} props=`, props)

  if (!id) {
    logUtil('loadByIdWorkoutAction').warn(`${logPrefix} [noop] no id`)
    return
  }

  const endpoint = getEndpointTrainingUtil(
    interpolateRouteUtil(
      WORKOUTS_ENDPOINT.LOAD_BY_ID, { id }
    )
  )

  return async (dispatch) => {
    try {
      await dispatch(
        loadReduxAction({
          type: WORKOUTS_ACTION.LOAD_BY_ID,
          payload: {
            endpoint,
            domainListPath: WORKOUTS_PATH.ALL,
            path: getPathFromDomainPathReduxUtil(WORKOUTS_DOMAIN, id),
            data: {
              id,
              className: WORKOUT_CLASS_NAME
            }
          },
          options: props.options
        })
      )
    } catch (error) {
      logUtil('loadByIdWorkoutAction').error(`${logPrefix} error=`, error)
    }
  }
}

export default loadByIdWorkoutAction
